import React from "react";
import Landing from "./Pages/Landing";
import Navbar from "./components/Navbar/Navbar";

function App() {
  return <Landing />;
}

export default App;
